import Guard from './middleware'
import DashboardLayout from 'src/pages/Dashboard/Layout/DashboardLayout.vue'
import Configuracion from 'src/pages/Dashboard/Configuracion/Configuracion.vue'
import Casas from 'src/pages/Dashboard/Configuracion/Casas/Casas.vue'
import Casa from 'src/pages/Dashboard/Configuracion/Casas/Casa.vue'
import Proveedores from 'src/pages/Dashboard/Configuracion/Proveedores/Proveedores.vue'
import Proveedor from 'src/pages/Dashboard/Configuracion/Proveedores/Proveedor.vue'
import Taxes from 'src/pages/Dashboard/Configuracion/Impuestos/GestionImpuestos.vue'
import Tax from 'src/pages/Dashboard/Configuracion/Impuestos/Tax.vue'
import Subproductos from 'src/pages/Dashboard/Configuracion/Subproductos/Subproductos.vue'
import Subproducto from 'src/pages/Dashboard/Configuracion/Subproductos/Subproducto.vue'
import Productos from 'src/pages/Dashboard/Configuracion/Productos/Productos.vue'
import Producto from 'src/pages/Dashboard/Configuracion/Productos/Producto.vue'
import Operarios from 'src/pages/Dashboard/Configuracion/Operarios/Operarios.vue'
import Operario from 'src/pages/Dashboard/Configuracion/Operarios/Operario.vue'
import CategoriasGenerales from 'src/pages/Dashboard/Configuracion/CategoriasGenerales/CategoriasGenerales.vue'
import CategoriasNegocio from 'src/pages/Dashboard/Configuracion/CategoriasGenerales/CategoriasNegocio.vue'
import EtiquetasNegocio from 'src/pages/Dashboard/Configuracion/Categorias/EtiquetasNegocio.vue'
import Clientes from 'src/pages/Dashboard/Configuracion/Clientes/Clientes.vue'
import Cliente from 'src/pages/Dashboard/Configuracion/Clientes/Cliente.vue'
import Modificadores from 'src/pages/Dashboard/Configuracion/Modificadores/Modificadores.vue'
import Modificador from 'src/pages/Dashboard/Configuracion/Modificadores/Modificador.vue'
import Agencias from 'src/pages/Dashboard/Configuracion/Agencias/Agencias.vue'
import Agencia from 'src/pages/Dashboard/Configuracion/Agencias/Agencia.vue'
import FormasPago from 'src/pages/Dashboard/Configuracion/FormasPago/FormasPago.vue'
import FormaPago from 'src/pages/Dashboard/Configuracion/FormasPago/FormaPago.vue'
import RangosHorarios from 'src/pages/Dashboard/Configuracion/General/RangosHorarios.vue'
import RangosMesas from 'src/pages/Dashboard/Configuracion/General/RangosMesas.vue'
import DatosFiscales from 'src/pages/Dashboard/Configuracion/General/DatosFiscales.vue'
import Herramientas from 'src/pages/Dashboard/Configuracion/Herramientas/Herramientas.vue'
import ConfiguracionAlmacen from 'src/pages/Dashboard/Configuracion/Almacen/ConfiguracionAlmacen.vue'
import CategoriasClientes from 'src/pages/Dashboard/Configuracion/CategoriasClientes/CategoriasClientes.vue'
import CategoriaCliente from 'src/pages/Dashboard/Configuracion/CategoriasClientes/CategoriaCliente.vue'
import ImportacionSage from 'src/pages/Dashboard/Configuracion/Sage/ImportacionSage.vue'
import ImportacionSinqro from 'src/pages/Dashboard/Configuracion/Sinqro/ImportacionSinqro.vue'
import ImportarClientes from 'src/pages/Dashboard/Configuracion/Clientes/ImportarClientes.vue'
import ImportarTarjetas from 'src/pages/Dashboard/Configuracion/Clientes/ImportarTarjetas.vue'

export default {
    path: '/configuracion',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [

        {
            path: 'categorias-clientes/:idBusiness?/:pag?',
            name: 'categorias-clientes',
            component: CategoriasClientes
        },
        {
            path: 'categorias-clientes/buscar/:query',
            name: 'search-categorias-clientes',
            component: CategoriasClientes
        },

        {
            path: 'categoria-cliente/:idBusiness/:idCompany/:pag?',
            name: 'categoria-cliente',
            component: CategoriaCliente
        },
        {
            path: 'herramientas/:idBusiness?',
            name: 'herramientas',
            component: Herramientas
        },
        {
            path: 'datos-fiscales',
            name: 'datos-fiscales',
            component: DatosFiscales
        },
        {
            path: 'rangos-horarios/:idBusiness?/:pag?',
            name: 'rangos-horarios',
            component: RangosHorarios
        },
        {
            path: 'rangos-de-mesas/:idBusiness?/:idTpv?/:pag?',
            name: 'rangos-de-mesas',
            component: RangosMesas
        },
        {
            path: '/',
            name: 'configuracion',
            component: Configuracion
        },
        {
            path: 'casas/:idBusiness?/:pag?',
            name: 'casas',
            component: Casas
        },
        {
            path: 'casa/:idBusiness/:idCasa?/:pag?',
            name: 'casa',
            component: Casa
        },
        {
            path: 'casas/buscar/:query',
            name: 'search-casas',
            component: Casas
        },
        {
            path: 'proveedores/buscar/:query',
            name: 'search-proveedores',
            component: Proveedores
        },
        {
            path: 'proveedores/:idBusiness?/:pag?',
            name: 'proveedores',
            component: Proveedores
        },
        {
            path: 'configuracion-almacen/buscar/:query',
            name: 'search-configuracion-almacen',
            component: ConfiguracionAlmacen
        },
        {
            path: 'configuracion-almacen/:idBusiness?/:pag?',
            name: 'configuracion-almacen',
            component: ConfiguracionAlmacen
        },
        {
            path: 'proveedor/:idBusiness/:idProveedor?/:pag?',
            name: 'proveedor',
            component: Proveedor
        },
        {
            path: 'etiquetas-negocio/:idBusiness?',
            name: 'etiquetas-negocio',
            component: EtiquetasNegocio
        },
        /*
         * La pantalla vieja de etiquetas se retira: descartaba filas al recorrer el arbol
         * -las huerfanas, las que no tienen tipo y todo lo que cuelga de ellas- y dejaba
         * cambiar la familia de una etiqueta ya usada.
         *
         * Sus rutas no se borran, redirigen: hay usuarios con la URL guardada y enlaces
         * repartidos por ahi, y una ruta que desaparece deja la pantalla en blanco sin
         * decir por que. Se conserva el idBusiness para no perder el negocio elegido.
         */
        {
            path: 'categorias/:idBusiness?/:pag?',
            name: 'categorias',
            redirect: to => ({ name: 'etiquetas-negocio', params: { idBusiness: to.params.idBusiness } })
        },
        {
            path: 'categorias/buscar/:query',
            name: 'search-categorias',
            redirect: { name: 'etiquetas-negocio' }
        },
        {
            path: 'categoria/:idBusiness/:idCategoria?/:pag?',
            name: 'categoria',
            redirect: to => ({ name: 'etiquetas-negocio', params: { idBusiness: to.params.idBusiness } })
        },
        {
            path: 'gestion-impuestos',
            name: 'taxes',
            component: Taxes
        },
        {
            path: 'gestion-impuestos/nuevo/:idBusiness?/:pag?',
            name: 'tax',
            component: Tax
        },
        {
            path: 'gestion-impuestos/editar/:idBusiness/:idTax?/:pag?',
            name: 'tax-edit',
            component: Tax
        },
        {
            path: 'gestion-impuestos/buscar/:query',
            name: 'search-taxes',
            component: Taxes
        },
        {
            path: 'materias-primas/:idBusiness?/:pag?',
            name: 'subproductos',
            component: Subproductos
        },
        {
            path: 'materias-primas/buscar/:query',
            name: 'search-subproductos',
            component: Subproductos
        },
        {
            path: 'materias-prima/:idBusiness/:idSubproducto?/:pag?',
            name: 'subproducto',
            component: Subproducto
        },
        {
            path: 'productos/:idBusiness?/:pag?',
            name: 'productos',
            component: Productos
        },
        {
            path: 'productos/buscar/:query',
            name: 'search-productos',
            component: Productos
        },
        {
            path: 'producto/:idBusiness/:idProducto/:idCategoria?/:pag?',
            name: 'producto',
            component: Producto
        },
        {
            path: 'producto/:idBusiness',
            name: 'nuevoproducto',
            component: Producto
        },
        {
            path: 'producto-sector/:idBusiness/:idSector?',
            name: 'nuevoproductosector',
            component: Producto
        },
        {
            path: 'producto-sector/:idBusiness/:idSector/:idProducto/:idCategoria?/:pag?',
            name: 'productosector',
            component: Producto
        },
        {
            path: 'operarios/:idBusiness?/:pag?',
            name: 'operarios',
            component: Operarios
        },
        {
            path: 'operarios/buscar/:query',
            name: 'search-operarios',
            component: Operarios
        },
        {
            path: 'operario/:idBusiness/:idOperario?/:pag?',
            name: 'operario',
            component: Operario
        },
        {
            path: 'categoriasGenerales/:idBusiness?',
            name: 'categorias-generales',
            component: CategoriasGenerales
        },
        {
            path: 'categorias-negocio/:idBusiness?',
            name: 'categorias-negocio',
            component: CategoriasNegocio
        },
        {
            path: 'clientes/buscar/:query',
            name: 'search-clientes',
            component: Clientes
        },
        {
            path: 'clientes/:idCompany?/:pag?',
            name: 'clientes',
            component: Clientes
        },
        {
            path: 'cliente/:idCompany/:idCliente?/:pag?',
            name: 'cliente',
            component: Cliente
        },
        {
            path: 'modificadores/:idBusiness?/:pag?',
            name: 'modificadores',
            component: Modificadores
        },
        {
            path: 'modificadores/buscar/:query',
            name: 'search-modificadores',
            component: Modificadores
        },
        {
            path: 'modificador/:idBusiness/:idModificador?/:pag?',
            name: 'modificador',
            component: Modificador
        },
        {
            path: 'agencias/:idBusiness?/:pag?',
            name: 'agencias',
            component: Agencias
        },
        {
            path: 'agencias/buscar/:query',
            name: 'search-agencias',
            component: Agencias
        },
        {
            path: 'agencia/:idBusiness/:idAgencia?/:pag?',
            name: 'agencia',
            component: Agencia
        },
        {
            path: 'formas-de-pago/:idBusiness?/:pag?',
            name: 'formas-de-pago',
            component: FormasPago
        },
        {
            path: 'formas-de-pago/buscar/:query',
            name: 'search-formas-de-pago',
            component: FormasPago
        },
        {
            path: 'forma-de-pago/:idBusiness/:idFormaPago?/:pag?',
            name: 'forma-de-pago',
            component: FormaPago
        },
        {
            path: 'importacion-sage',
            name: 'importacion-sage',
            component: ImportacionSage
        },
        {
            path: 'importacion-sinqro',
            name: 'importacion-sinqro',
            component: ImportacionSinqro
        },
        {
            path: 'importacion-sinqro/buscar/:query',
            name: 'search-productos-sinqro',
            component: ImportacionSinqro
        },
        // {
        //     path: 'clientes/import-clientes',
        //     name: 'import-clientes',
        //     component: ImportarClientes
        // },
        {
            path: 'clientes/import-clientes',
            name: 'import-clientes',
            component: ImportarClientes,
            props: route => ({
                datosClientes: route.params.datosClientes,
                idCompany: route.params.idCompany
            })
        },
        {
            path: 'clientes/import-tarjetas',
            name: 'import-tarjetas',
            component: ImportarTarjetas,
            props: route => ({
                datosTarjetas: route.params.datosTarjetas,
                idCompany: route.params.idCompany
            })
        },
    ]
}


// WEBPACK FOOTER //
// ./src/routes/configuracion.js